"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStores = void 0;
var react_1 = __importDefault(require("react"));
var contexts_1 = require("../contexts");
var useStores = function () { return react_1.default.useContext(contexts_1.storesContext); };
exports.useStores = useStores;
